export default "__VITE_ASSET__W3xBPUU8__"